<!-- TodaySummary.vue -->
<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<div>
					<el-form label-position="top" label-width="100px">
						<div class="row">
							<div class="col-md-5">	
								<el-form-item label="Station">
									<el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
										<el-option v-for="item7 in spbu.list" :key="item7.StationId" :label="item7.StationName" :value="item7.StationId">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="col-md-3">	
								<el-form-item label="Settlement Date:">
									<div class="block">								
										<el-date-picker
										v-model="dateRange"
										type="daterange"
										align="right"
										size="small" 
										unlink-panels
										range-separator="-"
										start-placeholder="Start date"
										end-placeholder="End date"
										format="yyyy-MM-dd"
										value-format="yyyy-MM-dd"
										:picker-options="pickerOptions">
										</el-date-picker>
									</div>
								</el-form-item>
							</div>
						</div>

						<div class="row">
							<div class="col-md-5" >
									<el-form-item label="Area">
										<el-radio-group v-model="area" size="small" name="area">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-5">
									<el-form-item label="Owner">
										<el-radio-group v-model="owner" size="small" name="owner">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.owner" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
						</div>

						<div class="row">
							<div class="col-md-5">
								<el-form-item label="Type">
									<el-radio-group v-model="stationtype" size="small" name="type">
										<el-radio-button :label="item5.value" v-for="(item5, index5) in options.types" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</div>

							<div class="col-md-5">
								<el-form-item label="Transaction Type">
									<el-radio-group v-model="transactiontype" size="small" name="transactiontype">
										<el-radio-button :label="item5.value" v-for="(item5, index5) in options.transactiontype" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</div>
						</div>

						<div class="row">
							<div class="col-md-5 mt-0">	
								<el-form-item label=" ">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Filter</el-button>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>
				<div class="mt-0">
					<ReportResultTable :reportname="'DOOutstandingReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Finance from '@/components/page/Finance.js'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
//import Loader from '@/components/loader/Loader2.vue'

export default {
	extends: Finance,
	components: { 
        ReportResultTable,
	},
	data(){
		return {
            urlRequestParams: '',
            reportdata: { data: [] },  // Ensure it's an object with a 'data' property
            stationid: '',
            plant: '',
            area: '',
            stationtype: '',
            owner: '',
            transactiontype: '',
            spbu: {
                list: [],
            },
			options: {
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				owner:[
					{ value: "", name: "ALL" }, 
					{ value: "COCO", name: "COCO" }, 
					{ value: "KSO", name: "KSO" }, 
					{ value: "TAC", name: "TAC" }, 
				],
				types:[
					{ value: '', name: 'ALL' },
					{ value: 'SPBU', name: 'SPBU' },
					{ value: 'SPBG', name: 'SPBG' },
					{ value: 'PERTASHOP', name: 'PERTASHOP' },
					{ value: 'SPBU-T', name: 'SPBU-T' },
					{ value: 'SHELTER', name: 'SHELTER' },
					{ value: 'MODULAR', name: 'MODULAR' },
				],
				transactiontype:[
					{ value: "", name: "ALL" }, 
					{ value: "RFID", name: "RFID" }, 
					{ value: "VOUCHER", name: "VOUCHER" }, 
					{ value: "EDC", name: "EDC" }, 
				],
			},
            loading: {
                table: false,
                isSuccess: false,
            },
            date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().bulanSekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
            pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},
        }
    },
    mounted() {
        this.$emit('childrenRoute');
        this.loadStationList();
        this.getData();
    },
    methods: { 
        async loadStationList(type='') {
			this.urlRequestParams = Config().apiURL
            this.urlRequestParams += "/fuel2/station?"  + (type ? "&type=" + type : "") + (this.plant ? "&plant=" + this.plant : "") + (this.stationid ? "&station=" + this.stationid : "");
			await AxiosWithJar().get(this.urlRequestParams).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},

        getData() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/cashdeposit/reportnoncash?'
            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
			this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')
            this.urlRequestParams+='&stationid='+this.stationid

            this.urlRequestParams+='&area='+this.area
            this.urlRequestParams+='&type='+this.stationtype
            this.urlRequestParams+='&owner='+this.owner
            this.urlRequestParams+='&transactiontype='+this.transactiontype

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;  // Update the data property of reportdata
				})
				.catch(error => {
					console.log(error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
        applyFilter() {
            this.getData()
        },
    }
}
</script>
